export default __webpack_public_path__ + "static/media/Letters2_19.7bb24bb4.png";